export function verificarCredenciales(usuario, password) {
  const AUTH_USERNAME = process.env.REACT_APP_AUTH_USERNAME || '';
  const AUTH_PASSWORD = process.env.REACT_APP_AUTH_PASSWORD || '';

  return usuario === AUTH_USERNAME && password === AUTH_PASSWORD;
}
